import React, {  useContext,  useState } from "react"
import { useEffect } from "react";


const  EditStateContext = React.createContext(false);
const useEdit = () => {
  
    return useContext(EditStateContext);
}

// create and export the AuthProvider - this is imported to the _app.js file
// and wrapped around the whole app, providing context to the whole app, and
// is called each time this specific context is accessed (updated or retrieved)
const EditProvider = ({ edit,  children }) => {
    const [state, dispatch] = useState(edit)
    const [createBid, dispatchCreateBid] = useState(false);
    useEffect(() => {
        dispatch(edit)
    }, [edit])
    return (

            <EditStateContext.Provider value={[state, dispatch, createBid, dispatchCreateBid]}>
                {children}
            </EditStateContext.Provider>
        
    )
};

export { EditProvider, useEdit };